module.exports = __webpack_public_path__ + "static/media/king-sukhothai-03.e000acc0.jpg";